<div class="search-container">
  <p-iconfield>
    <input
      aria-label="Search Input"
      class="app-input"
      id="search-input"
      pInputText
      size="normal"
      type="text"
      variant="filled"
      [formControl]="searchInput"
      [placeholder]="placeholder()"
    >
    <p-inputicon class="pi pi-search search-icon"/>
  </p-iconfield>
</div>
